module.exports = __webpack_public_path__ + "static/media/cplusplusLogo.ba973eb2.png";